import React from 'react';

export type TGuaranteesRootDependentSectionKey =
  | 'principal'
  | 'beneficiary'
  | 'baseRelations'
  | 'guaranteeForm';

type TGuaranteesRootApplicationSectionContext = {
  isReadOnly: boolean;
  requireChangesToEnableActions: boolean;
  onDependentSectionDirtyChange: (
    section: TGuaranteesRootDependentSectionKey,
    isDirty: boolean
  ) => void;
};

const GuaranteesRootApplicationSectionContext =
  React.createContext<TGuaranteesRootApplicationSectionContext | null>(null);

export const GuaranteesRootApplicationSectionProvider =
  GuaranteesRootApplicationSectionContext.Provider;

export const useGuaranteesRootApplicationSectionContext = () => {
  const context = React.useContext(GuaranteesRootApplicationSectionContext);

  if (!context) {
    throw new Error(
      'useGuaranteesRootApplicationSectionContext must be used within GuaranteesRootApplicationSectionProvider'
    );
  }

  return context;
};
